import api from '@/helpers/api';
import randomString from '@/helpers/randomString';

// remember last 10 items - just a simple, plain object
const history = {
  historyList: [],
  setContactTags(contactId, tags) {
    if (this.historyList.length > 9) {
      this.historyList.shift();
    }
    // existing record?
    let record = this.historyList.find(r => r.id === contactId);

    // new record
    if (!record) {
      record = {
        id: contactId,
      };
      // add to list
      this.historyList.push(record);
    }

    // update tags
    record.tags = [...tags];
  },
  getContactTags(contactId) {
    const record = { ...this.historyList.find(r => r.id === contactId) };
    return record ? record.tags : [];
  },
};

export default {
  // This is just to prevent wrong contact info to show up after starting a new conversation
  // This has to be refactored on rewrite
  setContactDataLoading({ commit }) {
    commit('CONTACT_DATA_IS_LOADING_SET', true);
  },
  contactDataFetch({ commit, rootGetters }, payload) {
    // @todo: check if contact is already loaded
    commit('CONTACT_DATA_IS_LOADING_SET', true);
    // OLD: api('GET', `/merchants/${payload.business_id}/contacts/${payload.contact_id}`)
    // NEW: organisation/<str:organisation_uid>/business/<str:business_uid>/contacts/<str:contact_uid>
    const me = rootGetters['organisation/me'];
    api('GET', `organisation/${payload.organisation_id}/contacts/${payload.contact_id}`, { _: process.env.VUE_APP_VERSION, __: me.platform_id, ____: window.todesktop ? 'd' : 'w' }, null, 'w')
      .then((response) => {
        // console.log('OK', response.data);
        if (response.status === 200) {
          commit('CONTACT_DATA_SET', response.data);
          // store tags for later
          history.setContactTags(payload.contact_id, response.data.tags.map(tag => tag.id));
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  syncContactTags({ commit }, payload) {
    // update the list of tags we have
    history.setContactTags(payload.contactId, payload.data.tags);
    // this updates (replaces) the list of tags a contact has
    api('PUT', `organisation/${payload.organisationId}/contacts/${payload.contactId}/sync-tags`, payload.data, null, 'w')
      // .then((response) => {
      //   if (response.status === 200) {
      //
      //   }
      // })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  addContactTagWhenCreated({ dispatch }, payload) {
    // this loads the list we have and adds a newly created tag
    // this solution solves issues when a new tag data is sent to backend and the user changes active contact data
    // get history
    const oldTags = history.getContactTags(payload.contactId);
    // combine old and new tags
    payload.data.tags = [...oldTags, ...payload.data.tags];
    // sync tags
    // dispatch('syncContactTags', payload);
  },
  contactAdded({ commit }, payload) {
    commit('ADD_CONTACT', payload);
  },
  contactUpdated({
    commit,
    dispatch,
    rootState,
    rootGetters,
  }, payload) {
    const me = rootGetters['organisation/me'];
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/contacts/${payload.contact_uid}`, { _: process.env.VUE_APP_VERSION, __: me.platform_id, ____: window.todesktop ? 'd' : 'w' }, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          if (rootState.chat.activeConversation && rootState.chat.activeConversation.contact.id === payload.contact_uid) {
            commit('CONTACT_DATA_SET', response.data);
          }

          dispatch('chat/updateConversationContact', response.data, { root: true });
          dispatch('contact/updateContactData', response.data, { root: true });
          // Also emit the event for all the components that need this update and do not show data directly from the store - e.g. contacts table
          window.eventBus.$emit('contact-updated', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  contactDeleted({ commit }, payload) {
    commit('DELETE_CONTACT', payload);
  },
  getContactNotes({ commit }, payload) {
    commit('LOADING_NOTES', true);
    const request = api('GET', `organisation/${payload.organisationId}/contacts/${payload.contactId}/contact-notes`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          response.data.data.forEach((note) => {
            note.animationKey = note.id;
          });
          commit('ADD_CONTACT_NOTES', response.data);
          commit('LOADING_NOTES', false);
        }
      })
      .catch((error) => {
        commit('LOADING_NOTES', false);
        commit('API_ERROR', error.response);
      });

    return request;
  },
  // Only updates the notes allready available in vuex, and inserts the ones that are not present
  silentlyUpdateNotes({ commit, rootState }, payload) {
    // Do nothing if the active conversation is not the one refferenced in the update or if notes are not in the view
    if (
      rootState.contactDetails.notesViewActiveForContact !== payload.contact_uid
    ) {
      return;
    }

    if (payload.action === 'deleted') {
      const noteIdToDelete = rootState.contactDetails.notes.data.findIndex(note => note.id === payload.note_id);
      if (noteIdToDelete >= 0) {
        commit('DELETE_NOTE', noteIdToDelete);
      }
    } else {
      api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/contacts/${payload.contact_uid}/contact-notes/${payload.note_id}`, null, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            if (payload.action === 'edited') {
              commit(
                'UPDATE_NOTE',
                {
                  noteId: payload.note_id,
                  data: response.data.data,
                },
              );
            } else if ( // Only add the note if user is on the last page of notes
              payload.action === 'added' &&
              rootState.contactDetails.notes.meta.current_page === rootState.contactDetails.notes.meta.last_page
            ) {
              commit('SILENT_ADD_NOTE', response.data.data);
            }
          }
        });
    }
  },
  clearContactNotes({ commit }) {
    commit('CLEAR_CONTACT_NOTES');
  },
  /** Adds a note to a store before the saving of a note. */
  addNote({ commit, rootState }) {
    commit('ADD_NOTE', { createdBy: { id: rootState.user.id } });
  },
  deleteNote({ commit }, payload) {
    commit('DELETE_NOTE', payload.index);
    let request;
    if (payload.organisationId && payload.contactId) {
      request = api('DELETE', `organisation/${payload.organisationId}/contacts/${payload.contactId}/contact-notes`, { note_id: payload.id, ...payload.data }, null, 'w');
    } else {
      request = Promise.resolve();
    }

    return request;
  },
  undeleteNote({ commit }, payload) {
    commit('UNDELETE_NOTE', payload);
  },
  saveNote({ commit }, payload) {
    commit('SAVE_NOTE', payload);
    const method = payload.id ? 'PUT' : 'POST';
    const data = payload.id ?
      {
        note_id: payload.id,
        content: payload.content,
      } :
      {
        content: payload.content,
      };
    const request = api(method, `organisation/${payload.organisationId}/contacts/${payload.contactId}/contact-notes`, data, null, 'w');

    request
      .then((response) => {
        if (response.status === 200 && !payload.id) {
          commit('SET_NOTE_ID', {
            index: payload.index,
            id: response.data.note.id,
          });
        }
      });

    return request;
  },
  activateSection({ commit }, section) {
    commit('SET_ACTIVE_DETAILS_SECTION', section);
  },
};
